import { PageTitle } from "../components/PageTitle";

const PrivacyPolicy = () => {
  return (
    <>
      <PageTitle
        title="Privacy Policy"
        subtitle="Your Privacy Matters to Us as Much as Your Child's Smile."
        bgImage="default.png"
      />

      <section className="flat-spacing-25">
        <div className="container">
          <div className="tf-main-area-page">
            <p>
              At HueHoppers, your privacy matters to us as much as your child's
              smile. We are committed to protecting your personal information
              and being transparent about how we use it.
            </p>

            <h5>Information We Collect</h5>
            <p>When you shop with us, we may collect the following:</p>
            <ul>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Name, email address, phone number, and delivery address
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Payment information (processed securely via third-party payment
                gateways — we never store card details)
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Device and browsing information (via cookies and analytics
                tools)
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Order history and communication records
              </li>
            </ul>

            <br />
            <h5>How We Use Your Information</h5>
            <p>We use your data to:</p>
            <ul>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Process and deliver your orders
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Send order confirmations, shipping updates, and invoices
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Respond to your queries and provide customer support
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Improve our website and shopping experience
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Send promotional offers and updates (only if you've opted in)
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Comply with legal and regulatory requirements
              </li>
            </ul>
            <br />

            <h5>Sharing Your Information</h5>
            <p>
              We do not sell your personal data. We only share it with trusted
              partners who help us run our business:
            </p>
            <ul>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Qikink — for order fulfilment and shipping
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Google & Meta — for analytics and advertising
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Payment Gateways — for secure transaction processing
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Legal Authorities — if required by law
              </li>
            </ul>
            <br />
            <h5>Data Security</h5>
            <p>
              We take reasonable technical and organisational measures to
              protect your personal data from unauthorised access, misuse, or
              disclosure. All payment transactions are encrypted and processed
              securely.
            </p>

            <h5>Your Rights</h5>
            <p>You have the right to:</p>
            <ul>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Access the personal data we hold about you
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Request correction of inaccurate data
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Request deletion of your data (subject to legal obligations)
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Opt out of marketing communications at any time
              </li>
            </ul>
            <p>
              To exercise any of these rights, email us at{" "}
              <a href="mailto:hello@huehoppers.com">hello@huehoppers.com</a>.
            </p>

            <br />
            <h5>Children's Privacy</h5>
            <p>
              HueHoppers is a kids' brand but our website is intended for use by
              parents and guardians. We do not knowingly collect personal data
              from children under the age of 13.
            </p>

            <br />
            <h5>Third-Party Links</h5>
            <p>
              Our website may contain links to third-party sites. We are not
              responsible for their privacy practices and encourage you to read
              their policies separately.
            </p>

            <h5>Changes to This Policy</h5>
            <p>
              We may update this Privacy Policy from time to time. Changes will
              be posted on this page with a revised effective date.
            </p>

            <h5>Grievance Officer</h5>
            <p>
              In accordance with the Information Technology Act, 2000 and
              applicable rules, any grievances regarding data privacy may be
              directed to:
            </p>
            <ul>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Email:{" "}
                <a href="mailto:hello@huehoppers.com">hello@huehoppers.com</a>
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                Response Time: Within 48 hours
              </li>
            </ul>

            <br />
            <h5>Contact Us</h5>
            <br />
            <ul>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                📧{" "}
                <a href="mailto:hello@huehoppers.com">hello@huehoppers.com</a>
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                📞 <a href="tel:+918527894154">+91 85278 94154</a>
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                🌐{" "}
                <a
                  href="https://www.huehoppers.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  www.huehoppers.com
                </a>
              </li>
              <li style={{ listStyle: "numeric", marginLeft: 30 }}>
                📍 New Delhi, India
              </li>
            </ul>

            <p>HueHoppers | New Delhi, India | Effective Date: June 2025</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
